import React from 'react';
import { DialogProps } from '@mui/material/Dialog';
import { DialogModal } from '../DialogModal';
import { EllipsisWithTooltip } from '../EllipsisWithToolTip';
import { Typography, TypographyType, TypographyVariant } from '../Typography';
import {
  ButtonsContainer,
  ConfirmationDialogStyled,
  ContentStyled,
  FooterStyled,
  HeaderCloseButtonWithIconStyled,
  HeaderStyled,
} from './ConfirmationDialog.style';
import { AvailableIcons } from '../Icon';

export const Title = ({
  children,
}: {
  children: React.ReactChild | React.ReactChild[];
}): JSX.Element => (
  <EllipsisWithTooltip tooltipPosition='top center' tooltipText={children as string}>
    <Typography type={TypographyType.Heading} variant={TypographyVariant.SmallBold}>
      {children}
    </Typography>
  </EllipsisWithTooltip>
);

export const ContentMainText = ({
  children,
  className,
}: {
  children: React.ReactChild | React.ReactChild[] | string;
  className?: string;
}): JSX.Element => (
  <Typography
    type={TypographyType.Paragraph}
    variant={TypographyVariant.ExtraLargeRegular}
    className={className}
  >
    {children}
  </Typography>
);

export const HeaderCloseButtonWithIcon = ({ onCancel }: { onCancel: () => void }): JSX.Element => (
  <HeaderCloseButtonWithIconStyled name={AvailableIcons.Close} onClick={onCancel} />
);

/**
 * Main component
 */
export interface ConfirmationDialogProps {
  children: JSX.Element | JSX.Element[];
  className?: string;
  onCancel?: () => void;
  disableAutoFocus?: boolean;
  sx?: DialogProps['sx'];
}

const onConfirmationDialogClick = (ev: React.MouseEvent) => {
  ev.stopPropagation();
};

export const ConfirmationDialog = ({
  children,
  className,
  onCancel,
  disableAutoFocus,
  sx,
}: ConfirmationDialogProps): JSX.Element => {
  return (
    <DialogModal open onClose={onCancel} disableAutoFocus={disableAutoFocus} sx={sx}>
      <ConfirmationDialogStyled onClick={onConfirmationDialogClick} className={className}>
        {children}
      </ConfirmationDialogStyled>
    </DialogModal>
  );
};

ConfirmationDialog.Header = HeaderStyled;
ConfirmationDialog.Title = Title;
ConfirmationDialog.Content = ContentStyled;
ConfirmationDialog.ContentMainText = ContentMainText;
ConfirmationDialog.Footer = FooterStyled;
ConfirmationDialog.ButtonsContainer = ButtonsContainer;
ConfirmationDialog.HeaderCloseButtonWithIcon = HeaderCloseButtonWithIcon;
